<template>
  <v-container class="pa-0">
    <v-alert class="mb-3 py-2" transition="scale-transition" dismissible v-model="showModalAlert" color="error" type="error" outlined>{{
      modalAlertText
    }}</v-alert>

    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
      <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />

      <action-button type="save" @click="save" />

      <action-button type="delete" @click="del(organisation.id)" v-if="$can('enrolment-delete') && modal != true" />

      <v-btn icon @click="toggleCollapse" class="darken-2" v-if="!modal">
        <v-icon>{{ collapseExpandIcon }}</v-icon>
      </v-btn>
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm4 xs12>
                <v-combobox
                  name="organisation.name"
                  v-model="organisation.name"
                  class="required-field"
                  v-validate="'required'"
                  :error-messages="errors.collect('organisation.name')"
                  :label="$t('enrolments.o_name')"
                  :items="organisations"
                  item-text="text"
                  item-value="vat"
                  :search-input.sync="orgNameSearch"
                  @change="updateOrgVat"
                  autocomplete="new-password"
                  clearable
                >
                  <template v-slot:append>
                    <span class="d-none">&nbsp;</span>
                  </template>
                  <template v-slot:append-item>
                    <span class="d-none">&nbsp;</span>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("organisations.org_does_not_exist") }}
                  </template>
                  <template v-slot:item="{ index, item }"> {{ item.text }} ({{ item.vat }}) </template>
                </v-combobox>
              </v-flex>
              <v-flex lg3 md4 sm4 xs12>
                <v-text-field
                  name="organisation.vat"
                  v-model="organisation.vat"
                  class="required-field"
                  v-validate="`required|max:50`"
                  :error-messages="errors.collect('organisation.vat')"
                  :hint="$t('global.helptext_vat')"
                  persistent-hint
                  @keypress="$keyDown_IntOnly($event)"
                  :label="$t('enrolments.o_vat')"
                  :append-outer-icon="'sync'"
                  @click:append-outer="searchOrgByVat(organisation.vat)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="organisation.comments"
                  v-model="organisation.comments"
                  rows="3"
                  auto-grow
                  :label="$t('addresses.comments')"
                  :error-messages="errors.collect('organisation.comments')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels v-model="clpsVA" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsVAIcon }}</v-icon>
                {{ $t("enrolments.visiting_address") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.visiting_street"
                    v-model="organisation.visiting_street"
                    :label="$t('enrolments.o_address_street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.visiting_zip"
                    v-model="organisation.visiting_zip"
                    :label="$t('enrolments.o_address_zip')"
                    @blur="visitingZipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.visiting_city"
                    v-model="organisation.visiting_city"
                    :label="$t('enrolments.o_address_city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.visiting_state"
                    v-model="organisation.visiting_state"
                    :label="$t('enrolments.o_address_state')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>

                <v-flex lg2 md4 sm6 xs12>
                  <v-autocomplete
                    name="organisation.visiting_country"
                    v-model="organisation.visiting_country"
                    :items="this.$dd_countries()"
                    item-text="text"
                    item-value="key"
                    :label="$t('enrolments.o_address_country')"
                    autocomplete="new-password"
                    :error-messages="errors.collect('organisation.visiting_country')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsIA" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsIAIcon }}</v-icon>
                {{ $t("enrolments.invoice_address") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.invoice_street"
                    v-model="organisation.invoice_street"
                    :label="$t('enrolments.o_address_street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.invoice_zip"
                    v-model="organisation.invoice_zip"
                    :label="$t('enrolments.o_address_zip')"
                    @blur="invoiceZipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.invoice_city"
                    v-model="organisation.invoice_city"
                    :label="$t('enrolments.o_address_city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.invoice_state"
                    v-model="organisation.invoice_state"
                    :label="$t('enrolments.o_address_state')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-autocomplete
                    name="organisation.invoice_country"
                    v-model="organisation.invoice_country"
                    :items="this.$dd_countries()"
                    item-text="text"
                    item-value="key"
                    :label="$t('enrolments.o_address_country')"
                    autocomplete="new-password"
                    :error-messages="errors.collect('organisation.invoice_country')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="organisation.invoice_email"
                    v-model="organisation.invoice_email"
                    :label="$t('enrolments.invoice_email')"
                    autocomplete="new-password"
                    v-validate="`email`"
                    :error-messages="errors.collect('organisation.invoice_email')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels :value="clpsDep" class="cstm-filter mt-4 elevation-0" v-if="organisation.id && !modal">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsDepIcon }}</v-icon>
                {{ $t("enrolments.departments") }}
              </span>

              <v-spacer></v-spacer>

              <v-layout row wrap class="pa-0 mt-0">
                <v-flex xs12 class="pa-0">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-text-field
                        :label="$t('global.search')"
                        v-model="search_dept_params.any"
                        @keydown="checkKeyPressFilterDepartment"
                        @click.stop="() => {}"
                        hide-details
                        dark
                        class="pa-0 ma-0"
                        autocomplete="new-password"
                      ></v-text-field>

                      <a>
                        <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="showForm(null, null, 'department')">
                          <v-icon small>fas fa-plus</v-icon>
                          <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                        </v-btn>
                      </a>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="dep_headers"
                  :items="departments"
                  :items-per-page="departments.length"
                  :options.sync="dep_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="dep_total"
                  :loading="dep_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.participant_id="{ item }">
                    <span v-if="item.participant_id">{{ item.participant.first_name + " " + item.participant.last_name }}</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button
                      v-if="$can('enrolment-edit') || $can('companies-access')"
                      @click="showForm(item.id, null, 'department')"
                      type="edit"
                      :icon_only="true"
                      small
                    />

                    <action-button
                      v-if="$can('enrolment-delete') || $can('companies-access')"
                      :disabled="Boolean(item.employees_count)"
                      @click="delDepartment(item.id)"
                      type="delete"
                      :icon_only="true"
                      small
                    />
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels :value="clpsEmp" class="cstm-filter mt-4 elevation-0" v-if="organisation.id && !modal">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsEmpIcon }}</v-icon>
                {{ $t("participants.employees") }}
              </span>

              <v-spacer></v-spacer>

              <v-layout row wrap class="pa-0 mt-0">
                <v-flex xs12 class="pa-0">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-text-field
                        :label="$t('global.search')"
                        v-model="search_students_params.any"
                        @keydown="checkKeyPressFilterStudent"
                        @click.stop="() => {}"
                        hide-details
                        dark
                        class="pa-0 ma-0"
                        autocomplete="new-password"
                      ></v-text-field>

                      <v-btn
                        class="darken-2 cstm-v-btn"
                        color="success"
                        v-if="selectedParticipants.length > 0"
                        @click.stop="courselistpopup_show"
                      >
                        <v-icon small>fas fa-plus</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.enrol") }}</span>
                      </v-btn>

                      <v-btn
                        class="darken-2 cstm-v-btn"
                        color="success"
                        v-if="selectedParticipants.length > 0"
                        @click.stop="deptselection_show"
                      >
                        <v-icon small>fas fa-plus</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.select_department") }}</span>
                      </v-btn>

                      <v-btn color="success" class="cstm-v-btn darken-2" @click.stop="partlistpopup_show" v-if="!$hasRole('company', true)">
                        <v-icon small>fas fa-plus</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.select") }}</span>
                      </v-btn>

                      <router-link
                        :to="BACKEND_URL + '/participants/create?from_module=companies&from_id=' + this.organisation.id"
                        class="d-content"
                      >
                        <action-button type="new" />
                      </router-link>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="par_headers"
                  :items="participants"
                  :items-per-page="participants.length"
                  :options.sync="par_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="par_total"
                  :loading="par_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  item-key="id"
                  :show-select="true"
                  v-model="selectedParticipants"
                  :must-sort="true"
                >
                  <template v-slot:item.first_name="{ item }">
                    <router-link
                      :to="{ path: BACKEND_URL + '/participants/edit/' + item.id, props: { id: item.id } }"
                      v-if="$can('participant-edit')"
                    >
                      {{ item.first_name }}
                    </router-link>
                  </template>

                  <template v-slot:item.employee_number="{ item }">
                    {{ getCompanyUserEmployeeNumber(item) }}
                  </template>

                  <template v-slot:item.department_id="{ item }">
                    {{ getCompanyUserDepartment(item) }}
                  </template>

                  <template v-slot:item.company_user_id="{ item }">
                    <v-simple-checkbox
                      :value="Boolean(getCompanyUserId(item))"
                      hide-details
                      dense
                      :disabled="loggedinuser.id == getCompanyUserId(item)"
                      @input="companyUserChange(item, !getCompanyUserId(item) ? 'create' : 'delete', $event)"
                    ></v-simple-checkbox>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button
                      type="download"
                      :text="$t('global.download') + ' ' + $t('certificates.modulename') + ' ' + $t('global.pdf')"
                      :icon_only="true"
                      small
                      @click="downloadCertificate(item.id)"
                    />
                    <action-button
                      type="edit"
                      :icon_only="true"
                      small
                      @click="showForm(organisation.id, item, 'enrolment-organisation-user')"
                    />
                    <action-button small type="delete" @click="removeEmployee(item.id)" :icon_only="true" />
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels :value="clpsCourse" class="cstm-filter mt-4 elevation-0" v-if="organisation.id && !modal">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsCourseIcon }}</v-icon>
                {{ $t("courses.company_internal_course") }}
              </span>

              <v-spacer></v-spacer>

              <v-layout row wrap class="pa-0 mt-0">
                <v-flex xs12 class="pa-0">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <a>
                        <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="showForm(null, null, 'course')">
                          <v-icon small>fas fa-plus</v-icon>
                          <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                        </v-btn>
                      </a>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="course_headers"
                  :items="courses"
                  :items-per-page="courses.length"
                  :options.sync="course_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="course_total"
                  :loading="course_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.coursetype_id="{ item }">
                    {{ item.coursetype.category }}
                  </template>

                  <template v-slot:item.address="{ item }">
                    {{ item.address.city }}
                  </template>

                  <template v-slot:item.instructor_id="{ item }">
                    {{ item.instructor.fullname }}
                  </template>

                  <template v-slot:item.start_datetime="{ item }">
                    {{
                      item.start_date
                        ? moment.utc(item.start_date).format(DATE_FORMAT) +
                          " " +
                          moment.utc(item.start_time, TIME_FORMAT).format(TIME_FORMAT)
                        : null
                    }}
                  </template>

                  <template v-slot:item.end_datetime="{ item }">
                    {{
                      item.end_date
                        ? moment.utc(item.end_date).format(DATE_FORMAT) + " " + moment.utc(item.end_time, TIME_FORMAT).format(TIME_FORMAT)
                        : null
                    }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_status(item.status) }}
                  </template>

                  <template v-slot:item.num_places="{ item }">
                    {{ item.num_places }}
                    <help-text
                      v-if="item.num_places && Boolean(item.num_enrolled > item.num_places)"
                      color="#dfa600"
                      icon="warning"
                      :tooltip="$t('courses.overbooked_tooltip')"
                    />
                  </template>

                  <template v-slot:item.num_enrolled_active_enrolment="{ item }">
                    <router-link :to="'/app/enrolments?course_id=' + item.id">
                      {{ item.num_enrolled_active_enrolment }}
                    </router-link>
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- <v-expansion-panels :value="clpsUser" class="cstm-filter mt-4 elevation-0" v-if="organisation.id && !modal && 1 == 0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsUserIcon }}</v-icon>
                {{ $t("users.title") }}
              </span>

              <v-spacer></v-spacer>

              <v-layout row wrap class="pa-0 mt-0">
                <v-flex xs12 class="pa-0">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>

                      <v-btn class="cstm-v-btn darken-2" color="success" @click.stop="showForm(null, null, 'user')">
                        <v-icon small>fas fa-plus</v-icon>
                        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.add") }}</span>
                      </v-btn>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="u_headers"
                  :items="users"
                  :items-per-page="users.length"
                  :options.sync="u_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="u_total"
                  :loading="u_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  item-key="id"
                  :must-sort="true"
                >
                  <template v-slot:item.first_name="{ item }">
                    {{ item.person.first_name }}
                  </template>

                  <template v-slot:item.last_name="{ item }">
                    {{ item.person.last_name }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button v-if="$can('user-access')" small type="edit" :icon_only="true" @click="showForm(item.id, 'user')" />
                    <action-button small type="delete" @click="removeUser(item.id)" :icon_only="true" />
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
      </v-container>
    </v-form>

    <courseListPopup
      :show="showCourseListPopup"
      :status_ids="[1]"
      :single_select="true"
      from_module="companies"
      :from_id="organisation.id"
      :number_of_enrolees="selectedParticipants.length"
      @callback_courselistpopup_cancel="callback_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_courselistpopup_submit"
    />

    <participantListPopup
      :key="reRenderPartListPopup"
      :show="showParticipantListPopup"
      :show_new_form_in_modal="true"
      from_module="companies"
      @callback_partlistpopup_cancel="callback_partlistpopup_cancel"
      @callback_partlistpopup_submit="callback_partlistpopup_submit"
    />

    <userListPopup
      :show="showUserListPopup"
      role="company"
      @callback_userlistpopup_cancel="callback_userlistpopup_cancel"
      @callback_userlistpopup_submit="callback_userlistpopup_submit"
    />

    <v-dialog v-model="showDialogForm" persistent max-width="80%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :enrolment_organisation_id="currentLoadedForm.enrolment_organisation_id"
          :cid="currentLoadedForm.cid"
          :autofill_data="currentLoadedForm.autofill_data"
          :modal="true"
          :locale="$locale_bcp47($getSetting('locale'))"
          :from_id="currentFromId"
          :from_module="currentFromModule"
          :participant="currentLoadedForm.participant"
          :participant_id="currentLoadedForm.participant_id"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>

    <v-dialog v-model="showDeptSelection" persistent max-width="50%">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-app-bar flat dense color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("enrolments.select_department") }}</v-toolbar-title>
                </v-app-bar>
                <v-card-text class="pa-2">
                  <v-flex xs12>
                    <v-autocomplete
                      name="department"
                      v-model="selectedDepartment"
                      :items="all_departments"
                      item-text="name"
                      item-value="id"
                      :label="$t('enrolments.department')"
                      autocomplete="new-password"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-spacer />
                  <action-button type="cancel" @click="deptselection_cancel" />
                  <action-button type="save" @click="deptselection_save" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import courseListPopup from "../../courses/partials/CourseListPopup.vue"
import userListPopup from "../../users/partials/UserListPopup.vue"
import participantListPopup from "../../participants/partials/ParticipantListPopup.vue"

export default {
  name: "EnrolmentOrganisationView",

  props: ["id", "modal"],

  components: {
    courseListPopup,
    userListPopup,
    participantListPopup,
    "department-form": () => import("../../enrolments/components/FormDepartment"),
    "enrolment-company-form": () => import("../../frontend/components/EnrolmentOrganisation.vue"),
    "user-form": () => import("../../users/components/Form"),
    "course-form": () => import("../../courses/components/Form"),
    "enrolment-organisation-user-form": () => import("@/modules/enrolments/partials/EnrolmentOrganisationUserForm")
  },

  data() {
    return {
      showModalAlert: false,
      modalAlertText: "",

      collapseExpand: 0,
      collapseExpandIcon: "mdi-collapse-all-outline",

      clpsVAIcon: "mdi-collapse-all-outline",
      clpsVA: 0,

      clpsIAIcon: "mdi-collapse-all-outline",
      clpsIA: 0,

      clpsEmpIcon: "mdi-collapse-all-outline",
      clpsEmp: 0,

      clpsUserIcon: "mdi-collapse-all-outline",
      clpsUser: 0,

      clpsDepIcon: "mdi-collapse-all-outline",
      clpsDep: 0,

      clpsCourseIcon: "mdi-collapse-all-outline",
      clpsCourse: 0,

      page_title: "",
      organisation: {},
      predata: {},

      showUserListPopup: false,
      showCourseListPopup: false,
      selectedParticipants: [],

      all_departments: [],
      selectedDepartment: null,
      showDeptSelection: false,

      organisations: [],
      orgNameSearch: null,

      showParticipantListPopup: false,
      participantIds: [],
      reRenderPartListPopup: 0,

      participants: [],
      par_ids: [],
      par_total: 0,
      par_show_loading: false,
      par_refresh: false,
      par_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      search_students_params: {
        any: ""
      },

      users: [],
      u_ids: [],
      u_total: 0,
      u_show_loading: false,
      u_refresh: false,
      u_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      departments: [],
      dep_ids: [],
      dep_total: 0,
      dep_show_loading: false,
      dep_refresh: false,
      dep_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"]
      },
      search_dept_params: {
        any: ""
      },

      courses: [],
      course_total: 0,
      course_show_loading: false,
      course_refresh: false,
      course_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"]
      },

      currentFormId: null,
      currentFormEnrolmentOrgId: null,
      currentAutoFillData: null,
      currentCourseID: null,
      currentForm: null,
      currentParticipantId: null,
      currentParticipant: null,
      currentFromModule: "enrolment-organisation",
      currentFromId: null,
      showDialogForm: false,

      coursePopupData: null,

      dictionary: {
        attributes: {
          "organisation.name": this.$t("enrolments.o_name"),
          "organisation.vat": this.$t("enrolments.o_vat"),
          "organisation.req_first_name": this.$t("enrolments.o_first_name"),
          "organisation.req_last_name": this.$t("enrolments.o_last_name"),
          "organisation.req_email": this.$t("enrolments.o_email"),
          "organisation.visiting_street": this.$t("enrolments.o_address_street"),
          "organisation.visiting_city": this.$t("enrolments.o_address_city"),
          "organisation.visiting_state": this.$t("enrolments.o_address_state"),
          "organisation.visiting_zip": this.$t("enrolments.o_address_zip"),
          "organisation.visiting_country": this.$t("enrolments.o_address_country"),
          "organisation.invoice_street": this.$t("enrolments.o_address_street"),
          "organisation.invoice_city": this.$t("enrolments.o_address_city"),
          "organisation.invoice_state": this.$t("enrolments.o_address_state"),
          "organisation.invoice_zip": this.$t("enrolments.o_address_zip"),
          "organisation.invoice_country": this.$t("enrolments.o_address_country"),
          "organisation.invoice_email": this.$t("enrolments.invoice_email"),
          "organisation.comments": this.$t("addresses.comments")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.organisation, this.predata, this.save, this.isFormValid)
    })
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.setPageTitle()
    } else {
      axios
        .get(this.API_URL + "enrolment/organisation/" + this.id)
        .then((res) => {
          this.organisation = res.data.data
          this.currentFromId = this.organisation.id
          this.setPageTitle()
          //this.student_list()
          //this.department_list()
          this.ddlist()

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.organisation))
        })
        .catch((err) => console.log(err))
    }
  },

  computed: {
    par_headers: {
      get() {
        return [
          { text: this.$t("participants.first_name"), value: "first_name" },
          { text: this.$t("participants.last_name"), value: "last_name" },
          { text: this.$t("participants.email"), value: "email" },
          { text: this.$t("participants.mobile"), value: "mobile" },
          { text: this.$t("participants.employee_number"), value: "employee_number" },
          { text: this.$t("enrolments.department"), value: "department_id" },
          { text: this.$t("enrolments.company_admin"), value: "company_user_id" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    u_headers: {
      get() {
        return [
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "email" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    dep_headers: {
      get() {
        return [
          { text: this.$t("enrolments.name"), value: "name" },
          { text: this.$t("enrolments.number"), value: "number" },
          { text: this.$t("enrolments.dept_chief"), value: "participant_id" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    course_headers: {
      get() {
        return [
          { text: this.$t("courses.id"), value: "id" },
          { text: this.$t("courses.name"), value: "name" },
          { text: this.$t("courses.location"), value: "address", hide: "mdAndDown" },
          { text: this.$t("courses.instructor_id"), value: "instructor_id" },
          { text: this.$t("courses.start_datetime"), value: "start_datetime" },
          { text: this.$t("courses.end_datetime"), value: "end_datetime", hide: "mdAndDown" },
          { text: this.$t("courses.num_places"), value: "num_places" },
          { text: this.$t("courses.num_enrolled"), value: "num_enrolled_active_enrolment", sortable: false },
          { text: this.$t("courses.num_enrolled_attendees"), value: "num_enrolled_attendees", sortable: false },
          { text: this.$t("courses.status"), value: "status" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    loggedinuser: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    currentLoadedForm: function () {
      let form,
        id,
        enrolment_organisation_id,
        autofill_data,
        cid,
        participant,
        participant_id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        enrolment_organisation_id = this.currentFormEnrolmentOrgId
        autofill_data = this.currentAutoFillData
        cid = this.currentCourseID
        form = this.currentForm
        participant_id = this.currentParticipantId
        participant = this.currentParticipant
      }

      return {
        id: id,
        enrolment_organisation_id: enrolment_organisation_id,
        autofill_data: autofill_data,
        cid: cid,
        form: form,
        participant: participant,
        participant_id: participant_id
      }
    }
  },

  watch: {
    par_refresh: {
      handler() {
        if (this.par_refresh) {
          this.student_list()
        }
      }
    },
    par_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.par_refresh = true
      }
    },
    u_refresh: {
      handler() {
        if (this.u_refresh) {
          //this.users_list()
        }
      }
    },
    u_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.u_refresh = true
      }
    },
    dep_refresh: {
      handler() {
        if (this.dep_refresh) {
          this.department_list()
        }
      }
    },
    course_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.course_refresh = true
      }
    },
    course_refresh: {
      handler() {
        if (this.course_refresh) {
          this.course_list()
        }
      }
    },
    dep_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.dep_refresh = true
      }
    },
    orgNameSearch: {
      handler: _.debounce(function (search) {
        if (search) {
          this.searchOrgVatByName(search)
        } else {
          this.organisations = []
        }
      }, 300)
    },
    clpsVA: {
      handler(newVal, oldVal) {
        this.clpsVAIcon = newVal === 1 || newVal == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsIA: {
      handler(newVal, oldVal) {
        this.clpsIAIcon = newVal === 1 || newVal == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsEmp: {
      handler(newVal, oldVal) {
        this.clpsEmpIcon = newVal === 1 || newVal == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsUser: {
      handler(newVal, oldVal) {
        this.clpsUserIcon = newVal === 1 || newVal == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsDep: {
      handler(newVal, oldVal) {
        this.clpsDepIcon = newVal === 1 || newVal == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsCourse: {
      handler(newVal, oldVal) {
        this.clpsCourseIcon = newVal === 1 || newVal == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  methods: {
    setPageTitle() {
      if (!_.has(this.organisation, "id")) {
        this.page_title = this.$t("enrolments.create_enrolment_org")
      } else {
        this.page_title = this.$t("enrolments.edit_enrolment_org", {
          name: this.organisation.name
        })
      }
    },

    ddlist() {
      axios
        .get(this.API_URL + "enrolmentorganisationdepartments" + "?show_all=true&query_enrolment_organisation_id=" + this.organisation.id)
        .then((res) => {
          this.all_departments = res.data.data
        })
        .catch((err) => console.log(err))
    },

    async department_list() {
      this.dep_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.dep_pagination
      let query = this.$queryString(this.dep_pagination, {
        ...this.search_dept_params,
        enrolment_organisation_id: this.organisation.id
      })

      await axios
        .get(this.API_URL + "enrolmentorganisationdepartments" + "?" + query)
        .then((res) => {
          this.departments = res.data.data
          this.dep_total = res.data.meta.total
          this.dep_refresh = false
          this.dep_show_loading = false

          this.dep_pagination.page = res.data.meta.current_page
          this.dep_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    async course_list() {
      this.course_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.course_pagination
      let query = this.$queryString(this.course_pagination, {
        company_id: this.organisation.id
      })

      await axios
        .get(this.API_URL + "courses" + "?" + query)
        .then((res) => {
          this.courses = res.data.data
          this.course_total = res.data.meta.total
          this.course_refresh = false
          this.course_show_loading = false

          this.course_pagination.page = res.data.meta.current_page
          this.course_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    filterDepartments(target) {
      this.dep_refresh = true
    },
    checkKeyPressFilterDepartment(e) {
      if (e.key == "Enter") {
        this.filterDepartments()
      }
    },

    users_list() {
      if (this.organisation.id) {
        this.u = true

        let ids = this.u_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.u_pagination
        let query = this.$queryString(this.u_pagination, {
          company_id: this.organisation.id
        })

        axios
          .get(this.API_URL + "users" + "?" + query)
          .then((res) => {
            this.users = res.data.data
            this.u_total = res.data.meta.total
            this.u_refresh = false
            this.u_show_loading = false

            this.u_pagination.page = res.data.meta.current_page
            this.u_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },

    async student_list() {
      if (this.organisation.id) {
        this.par_show_loading = true

        let ids = this.par_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.par_pagination
        let query = this.$queryString(this.par_pagination, {
          ...this.search_students_params,
          company_id: this.organisation.id,
          tenant_user_status: 1,
          any_department_name: this.search_students_params.any
        })

        await axios
          .get(this.API_URL + "participants" + "?resourcetype=user-basic&this_company_id=" + this.organisation.id + "&" + query)
          .then((res) => {
            this.participants = res.data.data
            this.par_total = res.data.meta.total
            this.par_refresh = false
            this.par_show_loading = false

            this.par_pagination.page = res.data.meta.current_page
            this.par_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    filterStudents(target) {
      this.par_refresh = true
    },
    checkKeyPressFilterStudent(e) {
      if (e.key == "Enter") {
        this.filterStudents()
      }
    },

    toggleCollapse() {
      this.collapseExpand = this.collapseExpand === 0 ? undefined : 0
      this.collapseExpandIcon =
        this.collapseExpand === 1 || this.collapseExpand == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"

      this.clpsVA = this.collapseExpand
      this.clpsIA = this.collapseExpand
      this.clpsEmp = this.collapseExpand
      this.clpsDep = this.collapseExpand
      this.clpsCourse = this.collapseExpand
    },

    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.organisation.id) {
              // Create
              axios
                .post(this.API_URL + "enrolment/organisation", {
                  __modal: this.modal,
                  name: this.organisation.name,
                  vat: this.organisation.vat,
                  v_street: this.organisation.visiting_street,
                  v_city: this.organisation.visiting_city,
                  v_state: this.organisation.visiting_state,
                  v_zip: this.organisation.visiting_zip,
                  v_country: this.organisation.visiting_country,
                  i_street: this.organisation.invoice_street,
                  i_city: this.organisation.invoice_city,
                  i_state: this.organisation.invoice_state,
                  i_zip: this.organisation.invoice_zip,
                  i_country: this.organisation.invoice_country,
                  invoice_email: this.organisation.invoice_email,
                  comments: this.organisation.comments
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.organisation = res.data.data

                      // JSON stringify and parse to remove variable reactiveness
                      this.predata = JSON.parse(JSON.stringify(this.organisation))
                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "companies",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.setPageTitle()
                        vm.student_list()
                        vm.$router.replace(this.BACKEND_URL + `/enrolments/organisations/view/${vm.organisation.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => {
                  if (err && err.response.status == 423) {
                    this.showModalAlert = true
                    this.modalAlertText = this.$formatErrorMessages(err.response.data.errors || this.$t("auth.error"))
                  }
                })
            } else {
              // Update
              axios
                .put(this.API_URL + "enrolment/organisation", {
                  __modal: this.modal,
                  id: this.organisation.id,
                  name: this.organisation.name,
                  vat: this.organisation.vat,
                  v_street: this.organisation.visiting_street,
                  v_city: this.organisation.visiting_city,
                  v_state: this.organisation.visiting_state,
                  v_zip: this.organisation.visiting_zip,
                  v_country: this.organisation.visiting_country,
                  i_street: this.organisation.invoice_street,
                  i_city: this.organisation.invoice_city,
                  i_state: this.organisation.invoice_state,
                  i_zip: this.organisation.invoice_zip,
                  i_country: this.organisation.invoice_country,
                  invoice_email: this.organisation.invoice_email,
                  comments: this.organisation.comments
                })
                .then((res) => {
                  vm.organisation = res.data.data
                  vm.setPageTitle()
                  vm.student_list()

                  // JSON stringify and parse to remove variable reactiveness
                  this.predata = JSON.parse(JSON.stringify(this.organisation))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "companies",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    del(id) {
      let vm = this

      if (this.organisation.active_enrolments_count > 0) {
        this.$awn.alert(this.$t("enrolments.active_enrolments_cannot_delete"))
      } else {
        this.$awn.confirm(
          this.$t("global.delete_message"),
          () => {
            return
          },
          () => {
            axios
              .delete(this.API_URL + "enrolment/organisation/" + id)
              .then((res) => {
                vm.$router.push(this.BACKEND_URL + "/enrolments/organisations")
                vm.$awn.success(vm.$t("global.delete_success"))
              })
              .catch((err) => console.log(err))
          },
          {
            labels: {
              confirm: "",
              confirmCancel: this.$t("global.yes"),
              confirmOk: this.$t("global.no")
            }
          }
        )
      }
    },

    delDepartment(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "enrolmentorganisationdepartment/" + id)
            .then((res) => {
              vm.dep_refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    deptselection_show() {
      this.showDeptSelection = true
    },
    deptselection_save() {
      let vm = this
      let pids = this.selectedParticipants.map((i) => i.id)

      axios
        .post(this.API_URL + "enrolment/organisation/add-employee-department", {
          company_id: this.organisation.id,
          department_id: this.selectedDepartment,
          participant_ids: pids.join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.par_refresh = true
            vm.deptselection_cancel()
            vm.$awn.success(vm.$t("global.create_success"))
          }
        })
        .catch((err) => {
          vm.deptselection_cancel()
        })
    },
    deptselection_cancel() {
      this.showDeptSelection = false
      this.selectedDepartment = null
      this.selectedParticipants = []
    },

    courselistpopup_show() {
      this.showCourseListPopup = true
    },
    callback_courselistpopup_submit(data) {
      this.coursePopupData = data
      this.callback_courselistpopup_cancel()

      let ids = data.map((i) => i.id)
      let uuids = data.map((i) => i.uuid)
      let participants = this.selectedParticipants.map((i) => ({
        id: i.id,
        first_name: i.first_name,
        last_name: i.last_name,
        email: i.email,
        date_of_birth: i.date_of_birth,
        mobile: i.mobile
      }))

      this.currentAutoFillData = {
        companies: [],
        company_id: this.organisation.id,
        company_vat: this.organisation.vat,
        participants: participants
      }
      this.currentCourseID = uuids.join(",")
      this.showForm(null, null, "enrolment-company")
    },
    callback_courselistpopup_cancel() {
      this.showCourseListPopup = false
    },
    coursePopupPostData(data) {
      let vm = this

      if (this.coursePopupData) {
        let ids = this.coursePopupData.map((i) => i.id)
        let pids = this.selectedParticipants.map((i) => i.id)
        let eids = data.map((i) => i.enrolment_id)

        axios
          .post(this.API_URL + "participant/createAttendee", {
            participant_ids: pids.join(","),
            course_ids: ids.join(","),
            enrolment_ids: eids.join(",")
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              vm.$awn.success(vm.$t("global.create_success"))
            }
          })
          .catch((err) => console.log(err))
      }
    },

    userlistpopup_show() {
      this.showUserListPopup = true
    },
    callback_userlistpopup_submit(data) {
      this.callback_userlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      axios
        .post(this.API_URL + "user/addcompanies", {
          company_id: this.organisation.id,
          user_ids: ids.join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.$awn.success(vm.$t("global.create_success"))
            vm.u_refresh = true
          }
        })
        .catch((err) => console.log(err))
    },
    callback_userlistpopup_cancel() {
      this.showUserListPopup = false
    },
    removeUser(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "user/removecompanies", {
              company_id: this.organisation.id,
              user_id: id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                vm.$awn.success(vm.$t("global.create_success"))
                vm.u_refresh = true
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    userlistpopup_show() {
      this.showUserListPopup = true
    },
    callback_userlistpopup_submit(data) {
      this.callback_userlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      axios
        .post(this.API_URL + "user/addcompanies", {
          company_id: this.organisation.id,
          user_ids: ids.join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.$awn.success(vm.$t("global.create_success"))
            vm.u_refresh = true
          }
        })
        .catch((err) => console.log(err))
    },
    callback_userlistpopup_cancel() {
      this.showUserListPopup = false
    },
    removeUser(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "user/removecompanies", {
              company_id: this.organisation.id,
              user_id: id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                vm.$awn.success(vm.$t("global.delete_success"))
                vm.u_refresh = true
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    partlistpopup_show() {
      this.reRenderPartListPopup++
      this.showParticipantListPopup = true
    },
    callback_partlistpopup_submit(data) {
      this.callback_partlistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      axios
        .post(this.API_URL + "enrolment/organisation/add-employee", {
          company_id: this.organisation.id,
          participant_id: ids.join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.$awn.success(vm.$t("global.create_success"))
            vm.par_refresh = true
          }
        })
        .catch((err) => console.log(err))
    },
    callback_partlistpopup_cancel() {
      this.showParticipantListPopup = false
    },

    visitingZipCodeChange() {
      this.$getCity(this.organisation.visiting_zip, this.organisation.visiting_country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.organisation, "visiting_city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.organisation, "visiting_city", null)
        })
    },
    invoiceZipCodeChange() {
      this.$getCity(this.organisation.invoice_zip, this.organisation.invoice_country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.organisation, "invoice_city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.organisation, "invoice_zip", null)
        })
    },
    searchOrgByVat(search) {
      let vm = this

      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then((res) => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer
            })
            // Automaticlly set the organisation name
            this.$set(this.organisation, "name", companyname || null)
            this.$set(this.organisation, "vat", data.organisasjonsnummer || null)
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.organisation, "name", null)
            vm.$set(vm.organisation, "vat", null)
          })

        // let promise = this.$api1881SearchVAT(search)
        // promise
        //   .then((res) => {
        //     let data = res.data
        //     if (data && data.contacts) {
        //       this.organisations = data.contacts.map((item) => {
        //         return {
        //           id: item.id,
        //           key: item.name,
        //           text: item.name,
        //           vat: item.organizationNumber
        //         }
        //       })

        //       this.$set(this.organisation, "name", this.organisations.length ? this.organisations[0].text : null)
        //       this.$set(this.organisation, "vat", this.organisations.length ? this.organisations[0].vat : null)
        //     } else {
        //       vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //     }
        //   })
        //   .catch(function (error) {
        //     vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //   })
      }
    },
    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find((i) => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then((res) => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter.slice(0, 3).map((item) => {
                  let companyname = this.$formatAPICompanyName(item.navn)
                  return {
                    key: companyname,
                    text: companyname,
                    vat: item.organisasjonsnummer,
                  }
                })
              }
            })
            .catch(function(error) {})
        }

        // let promise = this.$api1881SearchName(search)
        // promise.then((res) => {
        //   let data = res.data
        //   if (data && data.contacts) {
        //     this.organisations = data.contacts.map((item) => {
        //       return {
        //         id: item.id,
        //         key: item.name,
        //         text: item.name,
        //         vat: item.organizationNumber
        //       }
        //     })
        //   }
        // })
      }
    },
    updateOrgVat() {
      if (this.organisation.name && typeof this.organisation.name === "object") {
        let org = this.organisations.find((i) => i.key == this.organisation.name.key)
        if (org) {
          this.$set(this.organisation, "name", org.text || null)
          this.$set(this.organisation, "vat", org.vat || null)
          return
        }
        
        // let org = this.organisations.find((i) => i.vat == this.organisation.name.vat)
        // if (org) {
        //   let promise = this.$api1881SearchID(org.id)
        //   promise
        //     .then((res) => {
        //       let data = res.data
        //       if (data && data.contacts) {
        //         data = data.contacts[0]

        //         this.$set(this.organisation, "visiting_street", (data.geography.address.street || '') + " " + (data.geography.address.houseNumber || ''))
        //         this.$set(this.organisation, "visiting_zip", data.geography.address.postCode || '')
        //         this.$set(this.organisation, "visiting_city", data.geography.address.postArea || '')
        //         this.$set(this.organisation, "visiting_state", data.geography.county || '')
        //       }
        //     })
        //     .catch(function (error) {
        //       console.log(error)
        //     })

        //   this.$set(this.organisation, "name", org.text)
        //   this.$set(this.organisation, "vat", org.vat)
        //   return
        // }
      }

      this.$set(this.organisation, "name", this.organisation.name || null)
      this.$set(this.organisation, "vat", null)

      this.$set(this.organisation, "visiting_street", null)
      this.$set(this.organisation, "visiting_zip", null)
      this.$set(this.organisation, "visiting_city", null)
      this.$set(this.organisation, "visiting_state", null)
    },

    downloadCertificate(id) {
      let vm = this

      axios({
        url: this.API_URL + "participant/compile-expertise",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: id
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", "certificate.pdf")
            link.click()
          }
        })
        .catch((error) => {})
    },

    showForm(id, participant, type) {
      this.currentFormId = id
      this.currentFormEnrolmentOrgId = this.organisation.id
      this.currentForm = type + "-form"
      this.currentParticipant = participant
      this.currentParticipantId = participant ? participant.id : null
    },
    return_modal_form(data) {
      if (this.currentForm == "enrolment-company-form") {
        if (data && data != "cancel") {
          this.coursePopupPostData(data)
        }
      } else if (this.currentForm == "participant-form") {
        if (data) {
        }
      } else if (this.currentForm == "course-form") {
        this.course_refresh = true
      } else {
        this.dep_refresh = true
        this.par_refresh = true
        this.u_refresh = true
        this.ddlist()
      }

      this.return_modal_cancel_form()
    },
    return_modal_cancel_form(data) {
      this.currentFormId = null
      this.currentFormEnrolmentOrgId = null
      this.currentAutoFillData = null
      this.currentCourseID = null
      this.currentForm = null
      this.showDialogForm = false

      if (data && data.module == "enrolment-organisation-user") {
        this.par_refresh = true
      }
    },
    getCompanyUserId(participant) {
      let company = participant.companies.find((i) => i.id == this.organisation.id)
      if (company && company.user_id) {
        return company.user_id
      }
      return null
    },
    getCompanyUserDepartment(participant) {
      let company = participant.companies.find((i) => i.id == this.organisation.id)
      if (company && company.department_id) {
        return company.department.name
      }
      return null
    },
    getCompanyUserEmployeeNumber(participant) {
      let company = participant.companies.find((i) => i.id == this.organisation.id)
      if (company && company.employee_number) {
        return company.employee_number
      }
      return null
    },
    companyUserChange(participant, mode, value) {
      let vm = this
      let url = this.API_URL + (value ? "participant/add-company-access" : "participant/remove-company-access")
      let obj = {
        first_name: participant.first_name,
        last_name: participant.last_name,
        company_name: this.organisation.name
      }

      this.$awn.confirm(
        mode == "create" ? this.$t("enrolments.employee_user_access", obj) : this.$t("enrolments.employee_user_remove", obj),
        () => {
          axios
            .post(url, {
              participant_id: participant.id,
              company_id: this.organisation.id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                if (mode == "create") {
                  vm.$awn.success(vm.$t("global.create_success"))
                }

                if (mode == "delete") {
                  vm.$awn.success(vm.$t("global.delete_success"))
                }

                vm.par_refresh = true
              }
            })
            .catch((err) => console.log(err))
        },
        () => {},
        {
          labels: {
            confirm: ""
          }
        }
      )
    },
    removeEmployee(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "participant/remove-company", {
              company_id: this.organisation.id,
              participant_id: id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                vm.$awn.success(vm.$t("global.delete_success"))
                vm.par_refresh = true
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
